var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurso8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.64 131.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #b2c200;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#b2c200",
    x: 0,
    width: 131.64,
    height: 131.64,
    rx: 24.29,
    ry: 24.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M95.66,34.87h0s0,0,0,0c-.85-.85-2.02-1.38-3.3-1.38h0s-.29,0-.29,0c-.9,0-2.66,0-4.26.24-.38-.87-.92-1.66-1.59-2.32h0s0,0,0,0c-1.38-1.38-3.28-2.24-5.37-2.24h-1.67c.04-.16.06-.33.06-.5v-5.67c0-1.17-.95-2.13-2.13-2.13h-31.15c-1.17,0-2.13.95-2.13,2.13v5.67c0,.17.03.34.06.5h-1.67c-2.09,0-3.99.86-5.37,2.24h0c-1.38,1.39-2.24,3.29-2.24,5.38v23.8c0,1.8,2.02,15.39,4.02,27.21,1.53,9.05,3.08,17.18,3.79,18.54.65,1.26,1.95,2.44,3.7,3.24,1.41.64,3.16,1.06,5.13,1.07l20.72.1c1.61-.06,3.52-.6,5.19-1.57,1.51-.87,2.88-2.1,3.72-3.63.11-.2.19-.43.23-.67l4.69-28.12h6.57c1.28,0,2.45-.53,3.3-1.37h.01c.85-.87,1.38-2.04,1.38-3.32v-33.9c0-1.29-.53-2.46-1.38-3.31ZM48.07,25.13h26.9v4.05h-26.9v-4.05ZM74.05,69.76h-11.11v12.14c0,1.35-1.1,2.45-2.45,2.45s-2.45-1.1-2.45-2.45v-12.14h-11.07c-1.35,0-2.45-1.1-2.45-2.45s1.1-2.45,2.45-2.45h11.11v-12.14c0-1.35,1.1-2.45,2.45-2.45s2.45,1.1,2.45,2.45v12.14h11.07c1.35,0,2.45,1.1,2.45,2.45s-1.1,2.45-2.45,2.45ZM92.79,72.08c0,.12-.05.23-.12.31h0c-.08.08-.18.13-.31.13h-5.87l1.91-11.43c.04-.16.06-.32.06-.49v-12.62l.15-9.42c.02-1.9,2.59-.82,3.47-.82h.29c.12,0,.23.06.31.13h0c.08.08.13.19.13.31v33.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso8);
export default __webpack_public_path__ + "static/media/Recurso 8.300bb8e47b53b6d941d9be6b3702ea31.svg";
export { ForwardRef as ReactComponent };